import styled from 'styled-components'
import { MTLinearPercent, MTText } from '../../atoms'
import { ExportInboxButton } from '../../molecules'
import React from "react";

export const FavoritesTableStyled = styled.div`
  && {
    padding: 15px 0;
  }
  
  .was_read {
     font-weight: 400 !important;
     color: ${({ theme }) => theme.colors.black} !important;
     div:not([alt="avatar"]) {
       font-weight: 400 !important;
       color: ${({ theme }) => theme.colors.black} !important;
      }
    .value {
      font-weight: 400 !important;
    }
  }
  
  .not_read {
     font-weight: 600 !important;
     color: ${({ theme }) => theme.colors.black} !important;     
     div:not([alt="avatar"]) {
       color: ${({ theme }) => theme.colors.black} !important;   
     }
  }
  
  /* Avatar y nombre centrados en vertical (con una sola línea el nombre quedaba arriba) */
  .wrapImageName {
      flex-wrap: nowrap;
      align-items: center;
      position:relative;
  }
  
  /* Insignia del estado del pull en la esquina inferior derecha del avatar, dentro de su caja
     (antes colgaba 16 px por debajo y en la última fila generaba scroll en la tabla) */
  .isPullAcceptedIcon {
    position: absolute;
    right: -3px;
    bottom: -3px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    font-size: 14px;
    line-height: 1;
    border-radius: 50%;
    background-color: white;
    box-shadow: 0 0 0 1.5px white;
  }
  
  .MuiTableBody-root tr td:nth-child(2){
    padding-left: 0;
    padding-right: 0;
  }
  .MuiTableBody-root tr td:nth-child(3){
    padding-left: 0;
  }
  .MuiTableRow-root.MuiTableRow-head th:nth-child(2){
    padding-left: 0;
  }

  .MuiTableRow-head > th:not(:first-child) span{
    display: flex;
  }

  #svgFavorite{
    width:24px!important;
    height:24px!important;
  }

  .tagsColumn{
      padding-left: 5px;
  }
  
}
`

export const SubtextStyled = styled(props => <MTText {...props} />)`
  font-weight: normal;
  white-space:nowrap;
  color: ${({ theme }) => theme.colors.grey}
`

export const OfferStateImageStyled = styled.span`
   svg {
      width:  28px;
      height: 28px;
   }
`

export const ExportButton = styled(props => <ExportInboxButton {...props}/>)`
  /* Sin margen propio: el hueco lo da el gap de la cabecera y el último botón llega al borde */
  margin-right: 0 !important;
`

export const Grow = styled.div`
   flex-grow: 1;
`

// Nombre como en la bandeja de candidatos: 600 sin leer y 400 leído (antes 700 fijo)
// is_read solo se usa en el CSS: se saca de las props para que no llegue al DOM
// eslint-disable-next-line no-unused-vars
export const SearchCandidatureName = styled(({ is_read, ...props }) => <MTText {...props} />)`
   font-size: 14px;
   font-weight: ${props => (props.is_read ? 400 : 600)};
   line-height: 18px;
   text-align: start;
`

export const CandidatureText = styled(props => <MTText {...props} />)`
   margin-top: 5px;
   font-size: 12px;
   font-weight: 500;
   line-height: 18px;
   text-align: start;
`

export const LimitedDefaultCol = styled(props => <MTText {...props} title={ props.value } />)`
   max-width: 200px;
   text-overflow: ellipsis;
   white-space: nowrap;
   overflow: hidden;
   
`

export const MTLinearPercentStyled = styled(props => <MTLinearPercent {...props} />)`
  justify-content: flex-start !important;
`